import type { QueryClient } from "@tanstack/react-query";
import type { AuthSession } from "../../auth/keycloak.js";

/**
 * Drop the dashboard's cached reads for this caller (ADR-034 diff panel): the Manuals / Favourite manuals / Ratings
 * list (`["dashboard-manuals", realm, sub, archived]` — both archived variants, by prefix), the Übersicht
 * aggregate, the Tasks rows and the History feed. Called after every mutation that changes what they show — a favourite toggled, a manual's lifecycle,
 * a rating — so the pages never serve a just-removed favourite or a stale status inside the 60 s stale window.
 */
export function invalidateDashboard(qc: QueryClient, session: AuthSession | null): void {
  void qc.invalidateQueries({ queryKey: ["dashboard-manuals", session?.realm, session?.sub] });
  void qc.invalidateQueries({ queryKey: ["dashboard-overview", session?.realm, session?.sub] });
  void qc.invalidateQueries({ queryKey: ["dashboard-tasks", session?.realm, session?.sub] });
  void qc.invalidateQueries({ queryKey: ["dashboard-news", session?.realm, session?.sub] });
}
